// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/MovieCard.css */

.movie-card {
  flex: 0 0 auto;
  width: 210px;
  margin: 0 8px;
  cursor: pointer;
}

.movie-poster {
  position: relative;
  border-radius: var(--radius-md);
  overflow: hidden;
  aspect-ratio: 2 / 3;
  background: var(--surface);
  box-shadow: var(--shadow-sm);
  border: 1px solid transparent;
  transition: border-color var(--fast) var(--ease);
}

.movie-poster:hover {
  border-color: rgba(255, 255, 255, 0.85);
}

.movie-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.movie-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  box-shadow: var(--shadow-sm);
}

.movie-badge.liked {
  background: var(--like-soft);
  color: var(--like);
  border: 1px solid rgba(45, 212, 167, 0.4);
}

.movie-badge.disliked {
  background: var(--dislike-soft);
  color: var(--dislike);
  border: 1px solid rgba(255, 92, 114, 0.4);
}
`, "",{"version":3,"sources":["webpack://./src/components/MovieCard.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCAA0B;UAA1B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yCAAyC;AAC3C","sourcesContent":["/* src/components/MovieCard.css */\n\n.movie-card {\n  flex: 0 0 auto;\n  width: 210px;\n  margin: 0 8px;\n  cursor: pointer;\n}\n\n.movie-poster {\n  position: relative;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  aspect-ratio: 2 / 3;\n  background: var(--surface);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid transparent;\n  transition: border-color var(--fast) var(--ease);\n}\n\n.movie-poster:hover {\n  border-color: rgba(255, 255, 255, 0.85);\n}\n\n.movie-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.movie-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  backdrop-filter: blur(4px);\n  box-shadow: var(--shadow-sm);\n}\n\n.movie-badge.liked {\n  background: var(--like-soft);\n  color: var(--like);\n  border: 1px solid rgba(45, 212, 167, 0.4);\n}\n\n.movie-badge.disliked {\n  background: var(--dislike-soft);\n  color: var(--dislike);\n  border: 1px solid rgba(255, 92, 114, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
